/* eslint-disable @next/next/no-img-element */
"use client";

// import Image from "next/image";
import { block as _block$ } from "million/react-server";
import Link from "next/link";
const M$PageNotFound = function PageNotFound() {
  return <div className="grid h-screen w-full grid-cols-1 grid-rows-2 gap-0 py-[calc(90/1440_*_100vw)] pl-[calc(244/1440_*_100vw)] pr-[calc(150/1440_*_100vw)] md:grid-cols-[1fr_minmax(0,600px)] md:grid-rows-1">
      <div className="col-start-1 col-end-2 row-start-2 row-end-3 flex flex-col items-start justify-center md:row-start-1 md:row-end-2">
        <div className="mb-5 flex items-baseline gap-3">
          <h1 className="text-6xl font-semibold leading-[68px] text-text-dark-gray">
            404
          </h1>
          <h2 className="text-2xl font-semibold leading-normal text-text-light-gray">
            Error occured.
          </h2>
        </div>
        <div className="mb-12 flex w-full xl:w-[70%]">
          <p className="text-2xl font-semibold leading-normal text-text-dark-gray">
            Woops. Looks like this page doesn’t exist.
          </p>
        </div>
        <div className="mx-auto flex items-start justify-start md:mx-0">
          <Link className="inline-flex items-center justify-center gap-2 rounded bg-dark-blue px-8 py-4 text-gray98" href="/dashboard">
            Back to home
          </Link>
        </div>
      </div>
      <div className="col-start-1 col-end-2 row-start-1 row-end-2 flex flex-col items-center justify-center md:col-start-2 md:col-end-3">
        <img src="/images/404.png" alt="404" className="h-auto w-full max-w-full md:w-[41.67vw]" />
      </div>
    </div>;
};
const PageNotFound = M$PageNotFound;
export { PageNotFound };